import { Screen, useNavigate } from "flemo";
import { ClipboardListIcon } from "lucide-react";

import { AuthGuard } from "@/components/AuthGuard";
import { BottomNav } from "@/components/BottomNav";
import { EmptyState } from "@/components/EmptyState";
import { useGenerateExamMutation, useTestDatesQuery } from "@/hooks/queries";
import type { TestDateItem } from "@/types/common";

import { DataTable } from "./_components/DataTable";
import { Header } from "./_components/Header";
import { TestListSkeleton } from "./_components/TestListSkeleton";
import { getTestDateColumns } from "./columns";

export function TestListPage() {
  const { push } = useNavigate();
  const { data: testDates = [], isPending } = useTestDatesQuery();
  const { mutate: generateExam } = useGenerateExamMutation();

  const columns = getTestDateColumns();

  const handleRowClick = (item: TestDateItem) => {
    if (item.exam) {
      push("/tests/:id", { id: item.exam.id });
    } else {
      generateExam(item.date);
    }
  };

  return (
    <AuthGuard>
      <Screen sharedNavigationBar={<BottomNav />}>
        <main className="flex h-dvh flex-col overflow-hidden bg-tertiary pt-safe">
          <Header />

          <section className="mx-auto flex w-full max-w-4xl flex-1 min-h-0 flex-col bg-tertiary px-5 pb-[calc(56px+env(safe-area-inset-bottom,0px))] sm:pb-[calc(84px+env(safe-area-inset-bottom,0px))] text-card-foreground sm:px-6 md:rounded-2xl">
            <div className="flex-1 min-h-0 sm:rounded-md overflow-y-auto overscroll-none sm:bg-card pb-2 scrollbar-hidden">
              {isPending ? (
                <TestListSkeleton />
              ) : (
                <DataTable columns={columns} data={testDates} onRowClick={handleRowClick} />
              )}
              {!isPending && testDates.length === 0 && (
                <EmptyState
                  icon={ClipboardListIcon}
                  title="아직 테스트 기록이 없어요"
                  description="첫 테스트를 시작해 보세요!"
                />
              )}
            </div>
          </section>
        </main>
      </Screen>
    </AuthGuard>
  );
}
